import Vue from "vue";
import { getStyle } from "ccui/src/utils/dom";

const showellipsistip = {
  inserted(el, binding, vnode) {
    el.addEventListener("mouseenter", function(e) {
      let defalutSilent = !!Vue.config.silent;
      Vue.config.silent = true;
      vnode.componentInstance.disabled = true;
      const range = document.createRange();
      range.setStart(el, 0);
      range.setEnd(el, el.childNodes.length);
      const padding =
        (parseInt(getStyle(el, "paddingTop"), 10) || 0) +
        (parseInt(getStyle(el, "paddingBottom"), 10) || 0);
      const rangeHeight = Math.round(range.getBoundingClientRect().height);
      if (
        rangeHeight + padding > el.offsetHeight ||
        el.scrollHeight > el.offsetHeight
      ) {
        vnode.componentInstance.disabled = false;
      }

      Vue.config.silent = defalutSilent;
    });
  }
};
export default showellipsistip;
